/**
 * Check for mobile User Agent
 */

let isMobile = false;

const signText = document.querySelector(".sign__text");
const footerImg = document.querySelector(".parallax__img");

let lastKnownScrollPosition = 0;
let ticking = false;

window.addEventListener("load", mobileCheck());

function mobileCheck() {
  const ua = navigator.userAgent;
  const mobileUa = /Android|webOS|iPhone|iPad|iPod/i.test(ua);

  if (mobileUa) {
    isMobile = true;
  }
}

/**
 * Animation text scrolling on desktop
 */

const moveX = (pct) => {
  signText.style.setProperty("--moveX", `${(0.5 + pct) * (0.5 + pct) * 60}vw`);
};
const textHorizontalScroll = (scroll_pos) => {
  moveX(1 - scroll_pos / window.innerWidth);
};

const moveY = (pct) => {
  footerImg.style.setProperty("--moveY", `${(2 - pct) * (2 + pct) * 2}vw`);
};
const footerImgParallax = (scroll_pos) => {
  moveY(1 - scroll_pos / window.innerWidth);
};

if (isMobile === false) {
  window.addEventListener("scroll", function (e) {
    if (window.scrollY < 1300 && 1024 < window.innerWidth < 1919) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          textHorizontalScroll(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    } else if (window.scrollY < 1600 && window.innerWidth > 1919) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          textHorizontalScroll(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    } else if (window.scrollY > 7000) {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          footerImgParallax(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    } else {
      return;
    }
  });
} else {
  signText.classList.add("animatable", "fadeInRight", "animationDelay");
  footerImg.classList.add(
    "animatable",
    "footerFadeInUp",
    "animationDurationLong"
  );
}

/**
 * Intersection Observer for animations *
 */

const animationsOptions = {
  root: null,
  rootMargin: "50px",
  threshold: 0.1,
};

let animationsCallback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("animate-in");
    }
  });
};

let animationsObserver = new IntersectionObserver(
  animationsCallback,
  animationsOptions
);

document.querySelectorAll(".animatable").forEach((node) => {
  animationsObserver.observe(node);
});
